import styled from 'styled-components';

export default styled.div`
	border-radius: 0.8rem;
`;
